import { inject, Injectable } from '@angular/core';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import { map, Observable, take } from 'rxjs';
import { CreateUserRole, UserRoleForm, UserRolesTable } from '../user-roles.types';
import { UserRolesApiService } from './user-roles-api.service';
import { HttpStatusCode } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {
  private readonly userRolesApi = inject(UserRolesApiService);
  getTableData(tableState: DevicesPayload): Observable<UserRolesTable> {
    return this.userRolesApi.getAll(tableState).pipe(map(({ items: data, totalCount: total }) => ({ data, total })));
  }

  deleteUserRole(roleId: number): Observable<HttpStatusCode> {
    return this.userRolesApi.deleteUserRole(roleId).pipe(take(1));
  }

  createUserRole(payload: CreateUserRole): Observable<HttpStatusCode> {
    return this.userRolesApi.createUserRole(payload).pipe(take(1));
  }

  updateUserRole(payload: CreateUserRole, roleId: number): Observable<HttpStatusCode> {
    return this.userRolesApi.updateUserRole(payload, roleId).pipe(take(1));
  }

  transformFormDataToPayload(form: UserRoleForm): CreateUserRole {
    return {
      description: form.description,
      roleName: form.roleName,
      externalRoleName: form.externalRoleName,
      rolePermissions: form.permissions.flatMap(permission =>
        permission.resources
          .filter(resource => resource.state)
          .map(resource => ({
            resourceValue: permission.resourceValue.value,
            permissionValue: resource.resource.permissionValue,
            subCategory: permission.resourceValue.subcategory
          }))
      )
    };
  }
}
